import { Button } from "antd";
import { Spin } from "antd";
import { Table } from "antd";
import { useEffect } from "react";


export const LanListCPChanelWithPayout = (props) => {
    const { landatasource, pagination, onPageChange, downloading } = props;

    useEffect(()=>{
    },[landatasource])

    const columns = [
    {
      title: 'Applicant Name',
      dataIndex: 'applicantName',
      key: 'applicantName',
      align: 'center',
      width: 200,
    },
    {
      title: 'Dibursement File No',
      dataIndex: 'lanNo',
      key: 'lanNo',
      align: 'center',
      width: 190,
    },
    {
      title: 'Disbursal Date',
      dataIndex: 'disbDate',
      key: 'disbDate',
      align: 'center',
      width: 190,
    },
    {
      title: "Lan Status",
      dataIndex: "lanStatus",
      key: "lanStatus",
      align: "center",
      width: 190,
    },
    {
       title: 'Source Type',
      dataIndex: 'sourceType',
      key: 'sourceType',
      align: 'center',
      width: 190, 
    },
    {
       title: 'Source By',
      dataIndex: 'sourceBy',
      key: 'sourceBy',
      align: 'center',
      width: 190, 
    },
  //  editableRow ? 
   {
//       title: 'Partner Name',
//       dataIndex: 'partnerName',
//       key: 'partnerName',
//       align:'center',
//       fixed: 'left',
//       width: 200,
//      render: (text, record) => {
//   // console.log("Current record:", selectedPartner);
//   // console.log("record.partnerFirmId:", record.partnerId);

//   return editableRow === record.payoutId ? (
//     <Select
//       value={selectedPartner|| record.partnerId} 
//       onChange={(value) =>{ 
//         console.log("valuein",value)
//         handlePartnerChange(value, record)}}
//       showSearch
//       placeholder="Select Partner"
//       style={{ width: '100%', minWidth: '200px' }}
//       optionFilterProp="children"
//     >
//       {partnerList?.map((partner) => (
//         <Option style={{color: partner.pricingAdded?"black":"red"}} key={partner.partnerFirmId} value={partner.partnerFirmId}>
//           {partner.partnerFirmName}
//         </Option>
//       ))}
//     </Select>
//   ) : (
//     text
//   );
// }
// }
// :
// {
      title: 'Partner Name',
      dataIndex: 'partnerName',
      key: 'partnerName',
      align:'center',
      width: 200,
//      render: (text, record) => {
//   // console.log("Current record:", selectedPartner);
//   // console.log("record.partnerFirmId:", record.partnerId);

//   return editableRow === record.payoutId ? (
//     <Select
//       value={selectedPartner|| record.partnerId} 
//       onChange={(value) =>{ 
//         console.log("valuein",value)
//         handlePartnerChange(value, record)}}
//       showSearch
//       placeholder="Select Partner"
//       style={{ width: '100%', minWidth: '200px' }}
//       optionFilterProp="children"
//     >
//       {partnerList?.map((partner) => (
//         <Option style={{color: partner.pricingAdded?"black":"red"}} key={partner.partnerFirmId} value={partner.partnerFirmId}>
//           {partner.partnerFirmName}
//         </Option>
//       ))}
//     </Select>
//   ) : (
//     text
//   );
// }
},
    {
      title: 'Partner Code',
      dataIndex: 'partnerCode',
      key: 'partnerCode',
      align: 'center',
      width: 190,
    },
    {
      title: '1st Disb Amount',
      dataIndex: 'firstDisbAmount',
      key: 'firstDisbAmount',
      align: 'center',
      width: 190,
      // render: (_,amount) => amount.disbSeq > 1 ? 0 : amount.firstDisbAmount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    {
      title: 'Tranche Disb Amount',
      dataIndex: 'disbAmount',
      key: 'disbAmount',
      align: 'center',
      width: 190,
      render: (_, record) => (record.disbSeq > 1 ? record.disbAmount : 0
        ).toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    // ...(makerAction && checkerAction || recovry || remap || unhold || downloadAction
      // ? [
        // {
        //   title: "Action",
        //   dataIndex: 'Action',
        //   key: 'Action',
        //   fixed: 'right',
        //   align: 'center',
        //   width: 100,
        //   render:(_, record) => {
        //     return (
        //       <Button>
        //         Remap
        //       </Button>
        //     );
        //   },
        //   // render: (_, record) => {

        //   //   if (downloadAction) {
        //   //     return (
        //   //       <span style={{ color: '#ccc', cursor: 'not-allowed', fontSize: '18px' }}>
        //   //         <UnorderedListOutlined />
        //   //       </span>
        //   //     );
        //   //   }

        //   //   const menuItems = recovry ? fileApprovalId > 1 ? [] : [{ label: 'Recover Payout', key: 'RecoverPayout' }] :
        //   //     remap ?  [
        //   //       { label: 'Remapping History', key: 'RemappingHistory' },
        //   //       fileApprovalId > 1 || record.remapStageId <= 3 ? [] :
        //   //        { label: 'Remap Partner', key: 'RemapPartner' },
        //   //     ] :
        //   //       unhold ? fileApprovalId > 1 ? [] : [
        //   //         { label: 'Unhold Payout', key: 'UnholdPayout' }
        //   //       ] : fileApprovalId > 1 ? []
        //   //         :
        //   //         [
        //   //           { label: 'Remap Partner', key: 'RemapPartner' },
        //   //           { label: 'Hold Payout', key: 'HoldPayout' },
        //   //           // { label: 'Recover Payout', key: 'RecoverPayout' },

        //   //         ];
        //   //   const menu = (
        //   //     <Menu
        //   //       onClick={({ key }) => handleMenuClick(record, key)}
        //   //       items={menuItems}
        //   //     />
        //   //   );

        //   //   return (
        //   //     <>
        //   //       <Dropdown overlay={menu} trigger={['click']}>
        //   //         <UnorderedListOutlined
        //   //           style={{ cursor: 'pointer', fontSize: '18px' }}
        //   //         />
        //   //       </Dropdown>
        //   //       {editableRow === record.payoutId  && (
        //   //         <>
        //   //             <Button
        //   //               className="ant-btn ant-btn-default"
        //   //               style={{
        //   //                 fontSize: '0.7rem',
        //   //                 backgroundColor: '#1b8593',
        //   //                 color: '#fff',
        //   //                 margin: '3px',
        //   //                 borderRadius: '5px',
        //   //               }}
        //   //               onClick={() => handleSavePartnerChange(record)}
        //   //               loading={isLoading}
        //   //             >
        //   //               Save
        //   //             </Button>
        //   //               <span style={{ color: "#1b8593", fontSize: "0.8rem" }}>
        //   //               <CloseCircleOutlined onClick={handelCancleRemap} />
        //   //               </span>
        //   //             </>
        //   //           )}
        //   //         </>
        //   //     );
        //   //   },
        //   },
      //   ]
      // : []),
  ];

    return (
        <div>
          {downloading && (
                        <div style={{
                          position: 'absolute',
                          zIndex: 10,
                          top: 0,
                          left: 0,
                          width: '100%',
                          height: '100%',
                          background: 'rgba(255,255,255,0.5)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}>
                          <Spin tip="Loading..." size="large" />
                        </div>
                      )}
            <Table dataSource={landatasource}
                pagination={pagination}
                showSizeChanger={true}
                onChange={(pagination) => {
                    // Call the parent's handler if provided
                    if (props.onPageChange) {
                        props.onPageChange(pagination.current, pagination.pageSize);
                    }
                }} 
                columns={columns} rowKey={(record, index) => index} scroll={{ x: 'max-content', y: 'calc(100vh - 300px)' }} />
        </div>
    );
};





export default LanListCPChanelWithPayout;
